import React from 'react';

const ValentinesBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 80% 20%, rgba(225, 29, 72, 0.22) 0%, rgba(244, 63, 94, 0.15) 35%, transparent 65%), radial-gradient(circle at 15% 80%, rgba(159, 18, 57, 0.18) 0%, transparent 60%)'
        }}
      />

      <svg
        viewBox="0 0 1600 1000"
        className="w-full h-full object-cover"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <radialGradient id="loveMoon" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FFF1F2" />
            <stop offset="60%" stopColor="#FECDD3" />
            <stop offset="100%" stopColor="#FB7185" />
          </radialGradient>
          <filter id="heartGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
          </filter>
        </defs>

        {/* Luminous Romantic Crescent Moon */}
        <g transform="translate(1300, 160)">
          <circle cx="0" cy="0" r="50" fill="url(#loveMoon)" />
          <circle cx="-16" cy="-8" r="42" fill="#180812" />
          <circle cx="0" cy="0" r="56" stroke="#FB7185" strokeWidth="1.5" strokeOpacity="0.4" strokeDasharray="4 6" />
        </g>

        {/* Glowing Heart Constellations in Night Sky */}
        {[
          { x: 300, y: 180, s: 0.8, op: 0.7 },
          { x: 550, y: 120, s: 0.5, op: 0.5 },
          { x: 820, y: 220, s: 1.1, op: 0.8 },
          { x: 1050, y: 140, s: 0.6, op: 0.6 },
        ].map(({ x, y, s, op }, i) => (
          <g key={i} transform={`translate(${x}, ${y}) scale(${s})`} opacity={op}>
            <path
              d="M0,15 C-20,-10 -50,5 -30,35 L0,65 L30,35 C50,5 20,-10 0,15 Z"
              fill="#E11D48"
              filter="url(#heartGlow)"
            />
            <path
              d="M0,15 C-20,-10 -50,5 -30,35 L0,65 L30,35 C50,5 20,-10 0,15 Z"
              fill="#FFF1F2"
              opacity="0.6"
            />
          </g>
        ))}

        {/* Weeping Willow Branches & Romantic Foliage (Edges) */}
        <g stroke="#3D1225" strokeWidth="3" strokeLinecap="round" fill="none">
          <path d="M0,0 Q180,120 120,320 M50,0 Q240,160 220,380 M120,0 Q300,140 280,360" />
          <path d="M1600,0 Q1420,120 1480,320 M1550,0 Q1360,160 1380,380 M1480,0 Q1300,140 1320,360" />
        </g>

        {/* Romantic Arched Bridge & Gazebo Horizon */}
        <path d="M0 720 Q400 620 800 620 Q1200 620 1600 720 L1600 1000 L0 1000 Z" fill="#280E1C" />
        {/* Bridge Arch */}
        <path d="M600 740 Q800 670 1000 740 Z" fill="#180812" />
        {/* Reflective Lake Surface */}
        <rect x="0" y="780" width="1600" height="220" fill="#12040C" />
      </svg>
    </div>
  );
};

export default ValentinesBackgroundGraphics;
